@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.pickup-page {
  width: 100%;
  overflow-y: scroll;
}

.pickup-header {
  background-color: @usps-pickup-page--header--background-color;
  padding-left: 15px;
  padding-top: 15px;

  .pickup-title {
    margin-bottom: 8px;
  }
}

.pickup-tabs {
  display: flex;
  padding: 10px 10px 0;
  background-color: @usps-pickup-page--tabs--background-color;
  border-bottom: 1px solid @usps-pickup-page--tabs--border-color;
}

.tab-link {
  line-height: 34px;
  margin-right: 20px;
  font-size: 14px;
  cursor: pointer;
  color: @usps-pickup-page--tab-link--text-color;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: @usps-pickup-page--tab-link--hover--text-color;
    text-decoration: none;
  }

  &:focus {
    background-color: inherit;
    font-weight: 500;
  }

  &:after {
    content: '';
    height: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
  }
}

.tab-link:last-of-type {
  padding-right: 20px;
}

.active-tab-link {
  color: @usps-pickup-page--active-tab-link--text-color;
  background-color: @usps-pickup-page--active-tab-link--background-color;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-left: 1px solid @usps-pickup-page--active-tab-link--border-color;
  border-top: 1px solid @usps-pickup-page--active-tab-link--border-color;
  border-right: 1px solid @usps-pickup-page--active-tab-link--border-color;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: -1px;
  text-decoration: none;

  &:focus {
    background-color: @usps-pickup-page--active-tab-link--background-color;
  }
}
